import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const overviewSlideIn: CSSResult = css`
  .overview__comment {
    display: block;
    margin-top: ${csSpacing.spacing06};
  }

  .overview__footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: ${csSpacing.spacing06};
    width: 100%;
  }
`
